import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SoapNotes = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m12.25 6.851 2.363-2.363a1.67 1.67 0 0 1 2.357 0l1.393 1.393a1.666 1.666 0 0 1 0 2.357L16 10.601m-3.75-3.75-8.262 8.262a1.67 1.67 0 0 0-.488 1.179v3.06h3.06c.442 0 .866-.176 1.178-.489L16 10.601m-3.75-3.75 3.75 3.75'
          stroke='currentColor'
          strokeWidth='1.413'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.733 5.457a.5.5 0 0 0 .224-.224l.478-.957a.5.5 0 0 1 .894 0l.479.957a.5.5 0 0 0 .223.224l.957.478a.5.5 0 0 1 0 .894l-.957.478a.5.5 0 0 0-.223.224l-.479.957a.5.5 0 0 1-.894 0l-.478-.957a.5.5 0 0 0-.224-.224l-.956-.478a.5.5 0 0 1 0-.894z'
          fill='currentColor'
        />
        <path
          d='M15.216 15.845a.3.3 0 0 0 .13-.13l.277-.555a.29.29 0 0 1 .519 0l.277.555a.3.3 0 0 0 .13.13l.555.277a.29.29 0 0 1 0 .52l-.555.277a.3.3 0 0 0-.13.13l-.277.555a.29.29 0 0 1-.52 0l-.277-.555a.3.3 0 0 0-.13-.13l-.554-.278a.29.29 0 0 1 0-.518z'
          fill='currentColor'
        />
        <path
          d='M18.535 13.987a.42.42 0 0 0 .188-.188l.402-.803a.42.42 0 0 1 .75 0l.402.803a.42.42 0 0 0 .188.188l.803.401a.42.42 0 0 1 0 .751l-.803.402a.42.42 0 0 0-.188.188l-.401.803a.42.42 0 0 1-.751 0l-.402-.803a.42.42 0 0 0-.188-.188l-.803-.402a.42.42 0 0 1 0-.75z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M14.297 4.671a2.29 2.29 0 0 1 3.24 0l1.393 1.393a2.29 2.29 0 0 1 0 3.241l-1.921 1.921-4.634-4.633-.884.884 4.634 4.633-7.82 7.82a2.3 2.3 0 0 1-1.62.671h-3.06A.625.625 0 0 1 3 19.976v-3.06c0-.607.242-1.19.671-1.62z'
          fill='currentColor'
        />
        <path
          d='M4.733 6.207a.5.5 0 0 0 .224-.224l.478-.957a.5.5 0 0 1 .894 0l.479.957a.5.5 0 0 0 .223.224l.957.478a.5.5 0 0 1 0 .894l-.957.478a.5.5 0 0 0-.223.224l-.479.957a.5.5 0 0 1-.894 0l-.478-.957a.5.5 0 0 0-.224-.224l-.956-.478a.5.5 0 0 1 0-.894z'
          fill='currentColor'
        />
        <path
          d='M15.216 16.595a.3.3 0 0 0 .13-.13l.277-.555a.29.29 0 0 1 .519 0l.277.555a.3.3 0 0 0 .13.13l.555.277a.29.29 0 0 1 0 .52l-.555.277a.3.3 0 0 0-.13.13l-.277.555a.29.29 0 0 1-.52 0l-.277-.555a.3.3 0 0 0-.13-.13l-.554-.278a.29.29 0 0 1 0-.518z'
          fill='currentColor'
        />
        <path
          d='M18.535 14.737a.42.42 0 0 0 .188-.188l.402-.803a.42.42 0 0 1 .75 0l.402.803a.42.42 0 0 0 .188.188l.803.401a.42.42 0 0 1 0 .751l-.803.402a.42.42 0 0 0-.188.188l-.401.803a.42.42 0 0 1-.751 0l-.402-.803a.42.42 0 0 0-.188-.188l-.803-.402a.42.42 0 0 1 0-.75z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
